import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  ComposedChart,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer, Area, Line, Bar
} from 'recharts';

import {connect} from "react-redux";


class BankChart extends PureComponent {

	render () {
  	return (
      <ResponsiveContainer height={300} width='100%'>
        <ComposedChart
          width={600} 
          height={300} 
          data={this.props.data}
          margin={{top: 20, left: 30}}>
          <CartesianGrid strokeDasharray="3 3"/>
          <XAxis dataKey="Fecha" label={{ value: 'Fecha', position: 'insideBottomRight', offset: 0 }}/>
          <YAxis />
          <Tooltip/>
          <Legend />
          <Bar type="monotone" dataKey="Bancolombia" fill="#FFD700" stroke="#FFD700" stackId="a"/>
          <Bar type="monotone" dataKey="BBVA" fill="#004481" stroke="#004481" stackId="a" />
          <Bar type="monotone" dataKey="Davivienda" fill="#DC143C" stroke="#DC143C" stackId="a"/>
          <Bar type="monotone" dataKey="Otros" fill="#8FBC8F" stroke="#8FBC8F"stackId="a" />
          <Line type="monotone" dataKey="Total" stroke="#000000" />
        </ComposedChart>
      </ResponsiveContainer>
    );
  }
}

export default BankChart;
